module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3cd90ba16ab503943c4b0e87b5df175.png";